// P3-7 frente 1 — reordenar un elemento de una lista (de `from` a `to`). Es el
// núcleo del arrastre de la galería de fotos (ProductPage), extraído para poder
// probarlo: el reorden en sí no tenía cobertura (jsdom no arrastra). Equivale a
// arrayMove de dnd-kit: quita el elemento de `from` y lo inserta en `to`,
// correcto en ambas direcciones (hacia el principio o hacia el final).
// Índices fuera de rango → devuelve una COPIA sin cambios (no rompe).
export function reordenarLista(arr, from, to) {
  const list = [...(arr || [])];
  if (from < 0 || from >= list.length || to < 0 || to >= list.length) return list;
  const [m] = list.splice(from, 1);
  list.splice(to, 0, m);
  return list;
}
